/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-vars */
/**
 * 防抖函数
 * @param func 用户传入的防抖函数
 * @param wait 等待的时间
 * @param immediate 是否立即执行
 */
export function debounce(func, wait = 50, immediate = false) {
  // 缓存一个定时器id
  let timer = null;
  // 这里返回的函数时每次用户实际调用的防抖函数
  return function(...args) {
    // 如果已经设定过定时器了就清空上一次的定时器
    if (timer) clearTimeout(timer);
    if (immediate) {
      let callNow = !timer;
      //等待wait的时间间隔后，timer为null的时候，函数才可以继续执行
      timer = setTimeout(() => {
        timer = null;
      }, wait);
      //未执行过，执行
      if (callNow) func.apply(this, args);
    } else {
      // 开始一个定时器，延迟执行用户传入的方法
      timer = setTimeout(() => {
        //将实际的this和参数传入用户实际调用的函数
        func.apply(this, args);
      }, wait);
    }
  };
}

export function getUrlParameter(name) {
  // eslint-disable-next-line no-useless-escape
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

// h 偏移量, 为正数时,即将出现在屏幕中, 为负数时,必须超出屏幕底部一定高度才算出现在屏幕中
export function isInViewPort(el, h = 100) {
  const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  const top = el.getBoundingClientRect() && el.getBoundingClientRect().top;
  // console.log('top', top)
  return top <= viewPortHeight + h;
}

export function isWeixin() {
  //判断是否是微信
  let ua = navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) == 'micromessenger';
}

export function isAndroid() {
  let ua = navigator.userAgent;
  if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
    return true;
  } else {
    return false;
  }
}

// 根据URL参数,动态加载vConsole
export function initVConsole() {
  if (getUrlParameter('_vconsole_')) {
    import('vconsole').then(res => {
      let vConsole = res.default;
      if (window.vConsole) {
        console.log('vConsole 已经存在');
        return;
      }
      window.vConsole = new vConsole();
    });
  }
}

/**
 * 返回 querystring 对象
 * @param url
 * @return {Object} 对象
 */
export function queryParse(url) {
  var dic = {};
  url = url || location.search.slice(1);
  var array = url.split('&');
  for (var i = 0, len = array.length; i < len; i++) {
    var params = array[i].split('=');
    if (params[0]) {
      dic[decodeURIComponent(params[0])] = decodeURIComponent(params[1]);
    }
  }
  return dic;
}

/**
 * 将qs的对象序列化成 querystring 字符串
 *
 * @param {Object} obj
 * @return {String}
 */

export function queryStringify(obj) {
  let qs = [];
  for (let p in obj) {
    if (obj.hasOwnProperty(p)) {
      qs.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }
  return qs.join('&');
}

/**
 * 根据key返回url中的value
 * @param {String} key
 * @param {String} [url]
 * @returns {String}
 */

export function query(key, url) {
  return queryParse(url)[key];
}

export function getQuery(variable) {
  let query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return '';
}

export function getNonce(length) {
  length = length || 16;
  let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let pos = chars.length;
  let nonces = [];
  let i;
  for (i = 0; i < length; i++) {
    nonces.push(chars.charAt(Math.floor(Math.random() * pos)));
  }
  return nonces.join('');
}
